import { loadStripe } from "@stripe/stripe-js";

// Cache one load promise per runtime-resolved publishable key so every Stripe
// surface reuses the same Stripe object.
const stripePromisesByKey = new Map();

const stripeOptions = {
  developerTools: { assistant: { enabled: false } }
};

const getStripe = publishableKey => {
  if (!publishableKey) return null;

  if (!stripePromisesByKey.has(publishableKey)) {
    stripePromisesByKey.set(publishableKey, loadStripe(publishableKey, stripeOptions));
  }

  return stripePromisesByKey.get(publishableKey);
};

export default getStripe;
